import React from "react";


export default function Framework() {
    return (
        <div className="container">
            <div className="home-container">
                <h1 className="home-text">RAYTOLFAS - ФРЕЙМВОРКИ</h1>
            </div>

            <div className="content-container">
                <h1>@raytolfas/toastify - НАШ ПЕРВЫЙ ФРЕЙМВОРК</h1>
                <button onClick={() => window.location.href = "/framework/raytolfas_toastify"}>Посмотреть</button>
            </div>
        </div>
    );
}
